import { useEffect } from "react";
import { useAppDispatch, useAppSelector } from "../../store/hooks";
import { assetsApiClient } from "../../Assets/AssetsApiClient";
import { setHasInvalidIp, setIpStatusInfo } from "../../Assets/common/ipStatusSlice";
import { selectReleaseToggles } from "src/ReleaseToggles/releaseTogglesSlice";

export function useIpStatus(id: string | undefined) {
    const dispatch = useAppDispatch();
    useEffect(() => {
        if (!id) return;
        assetsApiClient.getInvestmentProgramStatus(id)
                .then(response => {
                    const invalidStatuses = [
                        "Invalid",
                        "Invalid-Pen.Approval",
                        "InvalidPenApproval"
                    ];
                    dispatch(setHasInvalidIp(invalidStatuses.includes(response.ipStatus)));
                    dispatch(setIpStatusInfo(response));
                })
                .catch(error => {
                    console.error("Failed to fetch IP status:", error);
                    dispatch(setIpStatusInfo(null));
                });

    }, [id, dispatch]);
}
